module.exports = __webpack_public_path__ + "static/media/Right.15a156d8.svg";